import { Checkbox, TableCell, TableRowProps } from "@mui/material";
import AppTableCell from "./AppTableCell";
import { AppTableRow as AppTableRowCustom } from "./AppTable.style";
import { GridColDef, RowType } from "./AppTable";

type AppTableRowProps<T> = TableRowProps & {
  row: T;
  columns: GridColDef<T>[];
  selectedList: string[];
  onSelectRow: (id: string) => void;
  hasCheckbox: boolean;
};

function AppTableRow<T extends RowType>(props: AppTableRowProps<T>) {
  const { row, columns, selectedList, onSelectRow, hasCheckbox, ...otherProps } = props;
  const isSelected = (id: string) => selectedList.indexOf(id) !== -1;
  const isItemSelected = isSelected(row.uid);

  return (
    <AppTableRowCustom {...otherProps}>
      {hasCheckbox && (
        <TableCell padding="checkbox">
          <Checkbox color="primary" checked={isItemSelected} onClick={() => onSelectRow(row.uid)} />
        </TableCell>
      )}
      {columns.map(col => (
        <AppTableCell key={col.field} field={col.field} align={col.align} render={col.render} row={row} />
      ))}
    </AppTableRowCustom>
  );
}

export default AppTableRow;
